module.exports = "<app-visit [requestType]=\"requestType\" [title]=\"title\" [isVisitReviewed]=\"isVisitReviewed\"></app-visit>"